// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2OZLf","footer":"ChangeClinic_footer__BTKl4"};